/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


// Path score needs to fit as bitwise mask inside Number
const MAX_SEGMENTS = Math.log2(Number.MAX_SAFE_INTEGER);


const matchPath = (path, pattern) =>
{
  path = path.split('/');
  pattern = pattern.split('/');

  if (pattern.length > MAX_SEGMENTS)
  {
    throw new Error('Route pattern exceeds max segments: ' + pattern.join('/'));
  }

  if (path.length !== pattern.length)
  {
    return null;
  }

  let score = 0;
  let args = {};

  for (let i = 0; i < pattern.length; ++i)
  {
    if (pattern[i].startsWith(':'))
    {
      args[pattern[i].slice(1)] = path[i];

      score = score * 2;
    }
    else if (pattern[i] === path[i])
    {
      score = score * 2 + 1;
    }
    else
    {
      return null;
    }
  }

  return { args, score };
}


export const matchRoute = (value, routes, fallback) =>
{
  let best = -1;
  let result = null;

  for (const type of Object.values(routes))
  {
    const match = matchPath(value, type);

    if (match && match.score > best)
    {
      best = match.score;

      result = { value, type, args: match.args };
    }
  }

  if (result == null && fallback)
  {
    return { value: fallback, type: fallback };
  }

  if (result == null)
  {
    throw new Error('Route parsing failed for: ' + value);
  }

  return result;
}
